import { render, staticRenderFns } from "./replies.vue?vue&type=template&id=12d13f6e&"
import script from "./replies.vue?vue&type=script&lang=js&"
export * from "./replies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports